// extracted by mini-css-extract-plugin
var _1 = "DocFlowMappingRecipientModal-modulebox__xR3IX";
var _2 = "DocFlowMappingRecipientModal-moduleform__FskyM";
export { _1 as "box", _2 as "form" }
